import React from 'react';
import Text from '../containers/Text';
import {TranslatedLink} from '../containers/Text';

const ShopBenefits = ({hasBoxes, acceptsSuitcases, isPaketFuxx, isPaketParcelLock, showDefaults=false}) => {
  const benefit = text => (
    <li>
      <Text id={text} className='t-md'/>
    </li>
  );

  return (
    <div>
        <ul className="shop-benefits my-md">
        {(showDefaults && !isPaketFuxx && !isPaketParcelLock) ? benefit('details.benefits.shipping') : null}
        {(showDefaults && isPaketFuxx) ? benefit('details.benefits.paketfuxx') : null}

        {(showDefaults && isPaketParcelLock) ? benefit('details.benefits.paketParcelLock.list-1') : null}
        {(showDefaults && isPaketParcelLock) ? benefit('details.benefits.paketParcelLock.list-2') : null}
        {(showDefaults && isPaketParcelLock) ? benefit('details.benefits.paketParcelLock.list-3') : null}

        {(showDefaults && !isPaketParcelLock) ? benefit('details.benefits.redirect') : null}
        {(showDefaults && !isPaketParcelLock) ? benefit('details.benefits.pickup') : null}
        {(showDefaults && !isPaketParcelLock) ? benefit('details.benefits.retours')  : null}

        {hasBoxes ? benefit('has-boxes') : null}
        {acceptsSuitcases ? benefit('acceptsSuitcases') : null}
        </ul>

        {   isPaketParcelLock = false // CR to hide it for now
            ?   <div className='shop-benefits-link-wrapper'>
                    <div>
                        <Text id='details.benefits.paketParcelLock.link-wrapper-text'/>
                        <TranslatedLink href='details.benefits.paketParcelLock.link-url' text='details.benefits.paketParcelLock.link-text' className='paketParcelLock-link' target='_blank' />
                    </div>
                </div>
            :   null
        }
    </div>
  )
};

export default ShopBenefits;
